module.exports = __webpack_public_path__ + "img/egg2.45aad5e1.gif";